// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  loginUrl: '/login',
  url: 'http://dev-cisr.alpha.simadvisory.com',
  // API_URL: `http://54.204.112.128:8084`,
  // API_URL: `https://dev-cisr.alpha.simadvisory.com`,
  API_URL: `https://dev-cisr.alpha.simadvisory.com/app`,
  ACCESS_API_URL: `https://dev-cisr.alpha.simadvisory.com/app`,
  KeycloakUrl: 'https://auth.dev.simadvisory.com/auth',
  Realm: 'SRT_Dev',
  ClientId: 'D_SRT_Client',
  psbuSegmentationUrl: 'https://dev-psbu.alpha.simadvisory.com/',
  // Realm: 'development',
  // Realm: 'SRT_Dev',
  // ClientId: 'angular-client',
  // ClientId: 'D_SRT_Client',
  //KeycloakUrl:'http://localhost:8181/auth',
  //Realm:'SR Tool - Dev',
  //ClientId:'SRTool_Client',
  //KeycloakUrl:'http://localhost:8181/auth',
  //Realm:'SR Tool - Dev',
  //ClientId:'SRTool_Client',
  KEYCLOAK_EXTRA_ARGS_PREPENDED:
    '--spi-login-protocol-openid-connect-legacy-logout-redirect-uri=true',
  version: 'vSR4.9',
  version1: 'v_EBU',
  version2: 'v_CCNA_5.1',
  version3: 'Powersys_5.0',
  version4: 'v_overall_5.0',
  version5: 'v_parts5.0',
  meritorDateOfUpdate: '12/08/2024',
  feedBackSubject: 'Feedback',
  toName: 'Praveen',
  NX_SUPERSET_DOMAIN: "https://reports.dev.cisr.alpha.simadvisory.com",
  NX_API_USER_ACCESS_URL: "https://dev-cisr.alpha.simadvisory.com/api/v1/user-access/reports/token",
  ID: "6729a57f-6b68-47c6-a255-b6c3fce0ef26",


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
